import pollQuestionService from '../../services/pollQuestionService'

class PollQuestionController {
  fetchActiveQuestionsForUser = pollQuestionService.fetchActiveQuestionsForUser
  fetchPollQuestionInstances = pollQuestionService.fetchPollQuestionInstances
  deletePollQuestionInstanceById = pollQuestionService.deletePollQuestionInstanceById
  savePollQuestionAnswers = pollQuestionService.savePollQuestionAnswers
}

export default new PollQuestionController()



// WEBPACK FOOTER //
// ../src/controllers/pollQuestionController/pollQuestionController.js